(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let revealObserver;

  const revealImmediately = (target) => {
    target.classList.add('lq-revealed');
    target.dataset.lqRevealReady = 'true';
  };

  const initializeReveals = (root) => {
    const targets = root.querySelectorAll('[data-lq-reveal]:not([data-lq-reveal-ready])');
    if (!targets.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      for (const target of targets) revealImmediately(target);
      return;
    }

    document.documentElement.classList.add('lq-motion-capable');

    revealObserver ||= new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        revealImmediately(entry.target);
        revealObserver.unobserve(entry.target);
      }
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    for (const target of targets) {
      target.dataset.lqRevealReady = 'true';
      revealObserver.observe(target);
    }
  };

  const initializeHeroVideo = (root) => {
    for (const button of root.querySelectorAll('[data-lq-hero-toggle]:not([data-lq-video-ready])')) {
      const section = button.closest('.lq-hero');
      const video = section?.querySelector('[data-lq-hero-video]');
      const label = button.querySelector('[data-lq-toggle-label]');
      if (!video || !label) continue;

      button.dataset.lqVideoReady = 'true';

      const sync = () => {
        const isPaused = video.paused;
        button.setAttribute('aria-pressed', String(isPaused));
        button.setAttribute('aria-label', isPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
        label.textContent = isPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
      };

      button.addEventListener('click', async () => {
        if (video.paused) {
          try {
            await video.play();
          } catch (error) {
            return;
          }
        } else {
          video.pause();
        }
        sync();
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);

      if (reducedMotion.matches) video.pause();
      sync();
    }
  };

  const initializeGalleryVideos = (root) => {
    if (reducedMotion.matches || !finePointer.matches) return;

    for (const video of root.querySelectorAll('[data-lq-gallery-video]:not([data-lq-hover-ready])')) {
      video.dataset.lqHoverReady = 'true';
      const item = video.closest('.lq-video-gallery__item');
      if (!item) continue;

      item.addEventListener('pointerenter', async () => {
        try {
          await video.play();
        } catch (error) {
          return;
        }
      });

      item.addEventListener('pointerleave', () => video.pause());
    }
  };

  const initialize = (root = document) => {
    initializeReveals(root);
    initializeHeroVideo(root);
    initializeGalleryVideos(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
